const { docToEntity } = require('./../../tools')

exports.listProgramsByIds = async function (state, programIds) {
  const doc = await state.dal.program.getPrograms(state)
  return docToEntity(doc, true, programIds)
}
